'use strict';

var classes = {"avatar":"avatar__onNX5"};

module.exports = classes;
//# sourceMappingURL=overflow-avatar.module.scss.js.map
